import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Input from 'Components/Globals/Elements/Input/loadable';
import Button from 'Components/Globals/Elements/Button';
import { walletPaymentActions, walletPaymentSelectors } from 'Ducks';
import { SAGA_REQUEST_KEY } from 'Constants';
import { composeClassNames, convertRialToToman } from 'Helpers';
import useServices from 'Hooks/useServices';
import GENERAL_REGEX from 'Helpers/regex';
import useContent from 'Hooks/useContent';

import styles from './styles.module.scss';
import strings from './strings';

function FactorAmount() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { businessId } = useServices();

	const defaultAmount = useSelector(walletPaymentSelectors.selectAmount);
	const { formatMessage } = useContent();
	const [amount, setAmount] = useState(
		defaultAmount ? convertRialToToman(defaultAmount).replaceAll(',', '،') : ''
	);
	const [balance, setBalance] = useState(defaultAmount ? defaultAmount : 0);
	const [loading, setLoading] = useState(false);

	const onChangeInput = (val) => {
		let value = val.toString();
		value = value.replace(GENERAL_REGEX.removeNonDigit.pattern, '');
		setBalance(value * 10);
		value = value.replace(GENERAL_REGEX.septateThreeCharacter.pattern, '،');
		setAmount(value);
	};
	const onSubmitAmount = () => {
		setLoading(true);
		dispatch(
			walletPaymentActions.newTransactionRequest({
				amount: balance,
				business_id: businessId,
				navigate,
				[SAGA_REQUEST_KEY.DISABLE_TOAST]: true,
			})
		);
	};
	useEffect(() => {
		dispatch(walletPaymentActions.checkBarcodeClear());
	}, [dispatch]);

	useEffect(() => {
		const timeoutId = setTimeout(() => {
			const inputElement = document.querySelector('input[name="amount"]');
			if (inputElement) {
				inputElement.focus();
			}
		}, 200);

		return () => clearTimeout(timeoutId);
	}, []);

	return (
		<div className={styles.wrapper}>
			<p className='txt-dark text-center m-16 mt-24'>
				{formatMessage(strings.amountDescription)}
			</p>
			<Input
				name={'amount'}
				className={composeClassNames(['mv-8 mh-16', styles.input])}
				value={amount}
				onChange={onChangeInput}
				endIcon='toman'
				textCenter
				type='tel'
				autoFocus
			/>
			<Button
				label={formatMessage(strings.buttonLabel)}
				onClick={() => onSubmitAmount()}
				className={composeClassNames(['m-16', styles.button])}
				disabled={!amount || amount === '0'}
				isLoading={loading}
			/>
		</div>
	);
}

export default FactorAmount;
